import Icon from 'veui/components/Icon'
import { IconRecommendSquare } from 'dls-icons-vue'

Icon.register('recommend-square', IconRecommendSquare)
